export const calculateEcpm = (revenueAmount, exposureCount) => {
  const revenue = Number(revenueAmount) || 0;
  const exposure = Number(exposureCount) || 0;
  return exposure > 0 ? (revenue / exposure) * 1000 : 0;
};

export const formatEcpm = value => Number(value || 0).toLocaleString("ko-KR", {
  minimumFractionDigits: 1,
  maximumFractionDigits: 1,
});
